import SnackbarDefault from './Snackbar';

export default SnackbarDefault;



// WEBPACK FOOTER //
// ./src/client/Components/Snackbar/index.js